import { useQuery } from "@tanstack/react-query";
import { fetchProjects } from "../services/projectsServices";

const useProjects = (projectID = null) => {
  return useQuery({
    queryKey: projectID ? ["project", projectID] : ["projects"],
    queryFn: () => fetchProjects(projectID),
    enabled: projectID ? !!projectID : true,
  });
};

export default useProjects;
